"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _formModule = _interopRequireDefault(require("./form.module.scss"));

var _excluded = ["onSubmit", "id", "action", "children", "className"];

var Form = function Form(_ref) {
  var onSubmit = _ref.onSubmit,
      id = _ref.id,
      action = _ref.action,
      children = _ref.children,
      className = _ref.className,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classNames = (0, _classnames.default)(_formModule.default.Form, className);
  return /*#__PURE__*/_react.default.createElement("form", (0, _extends2.default)({
    className: classNames,
    id: id,
    action: action,
    onSubmit: onSubmit
  }, restProps), children);
};

Form.propTypes = {
  onSubmit: _propTypes.default.func,
  id: _propTypes.default.string,
  action: _propTypes.default.string,
  className: _propTypes.default.string,
  noValidate: _propTypes.default.bool
};
var _default = Form;
exports.default = _default;